/*** IMPORTS FROM imports-loader ***/
var jQuery = require("jquery");
var $ = require("jquery");

import React from 'react';
import { connect } from 'react-redux';
import { injectIntl } from 'react-intl';
import { routerActions } from 'react-router-redux';
import SideBar from 'loracoms/SideBar';
import SidebarContainer from 'loracoms/SidebarContainer';
import PageLoading from 'loracoms/PageLoading';
import PageNoPerm from 'loracoms/PageNoPerm';
import IntlMsg from 'lorautils/intl/IntlMsg';
import config from 'loracfg';
import TdmSvg from './img/TDM.svg';
import HeartMapSvg from './img/heartmap.svg';
import styles from './styles.scss';

const defaultProps = {
  view: '',
  plan: {},
};

const propTypes = {
  intl: React.PropTypes.any.isRequired,
  view: React.PropTypes.string.isRequired,
  plan: React.PropTypes.object,
  children: React.PropTypes.node.isRequired,
  pushState: React.PropTypes.func.isRequired,
};

class Network extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      view: props.view,
      plan: props.plan,
    };
    this.intlMsg = new IntlMsg(props.intl, 'network');
  }

  componentWillReceiveProps(nextProps) {
    const { plan, view } = nextProps;
    if (plan !== this.props.plan) {
      this.setState({ plan });
    }
    if (view !== this.props.view) {
      this.setState({ view });
    }
  }

  renderSideBar() {
    const { pushState } = this.props;
    const { view } = this.state;
    return (
      <SideBar
        height={window.innerHeight}
        title={this.intlMsg.msg('sidebar.title')}
        menuItems={[{
          icon: <span className="glyphicons glyphicons-voice" />,
          text: 'ADR',
          onClick: () => pushState('/network/adr'),
          active: view === 'adr' || view === '',
        }, {
          icon: <span className="glyphicons glyphicons-equalizer" />,
          text: this.intlMsg.msg('sidebar.menuitems.band'),
          onClick: () => pushState('/network/chplans'),
          active: view === 'chplans',
        }, {
          icon: <span className="glyphicons glyphicons-remote-control" />,
          text: this.intlMsg.msg('sidebar.menuitems.node'),
          onClick: () => pushState('/network/node'),
          active: view === 'node',
          show: config.profile === 'hide',
        }, {
          icon: <span className="glyphicons glyphicons-wifi-alt" />,
          text: this.intlMsg.msg('sidebar.menuitems.gateway'),
          onClick: () => pushState('/network/gateway'),
          active: view === 'gateway',
          show: config.profile === 'hide',
        }, {
          icon: <span className="glyphicons glyphicons-signal" />,
          text: this.intlMsg.msg('sidebar.menuitems.quality'),
          onClick: () => pushState('/network/quality'),
          active: view === 'quality',
          show: config.profile === 'cloud',
        }, {
          icon: <span className="glyphicons glyphicons-cardio" />,
          text: this.intlMsg.msg('sidebar.menuitems.capacity'),
          onClick: () => pushState('/network/capacity'),
          active: view === 'capacity',
          show: config.profile === 'cloud',
        }, {
          icon: <span className="glyphicons glyphicons-alert" />,
          text: this.intlMsg.msg('sidebar.menuitems.unauthorized'),
          onClick: () => pushState('/network/unauthorized'),
          active: view === 'unauthorized',
          show: config.profile === 'cloud',
        }, {
          icon: <span className="glyphicons glyphicons-ruler" />,
          text: this.intlMsg.msg('sidebar.menuitems.coverage'),
          onClick: () => pushState('/network/coverage'),
          active: view === 'coverage',
          show: config.profile === 'cloud',
        }, {
          icon: <span className="glyphicons glyphicons-pie-chart" />,
          text: this.intlMsg.msg('sidebar.menuitems.capacityCalculation'),
          onClick: () => pushState('/network/capacityCalculation'),
          active: view === 'capacityCalculation',
          show: config.profile === 'cloud',
        }, 
        // {
        //   icon: <span className="glyphicons glyphicons-car" />,
        //   text: this.intlMsg.msg('sidebar.menuitems.roadtest'),
        //   onClick: () => pushState('/network/roadtest'),
        //   active: view === 'roadtest',
        //   // show: config.profile === 'cloud',
        // }, 
        {
          icon: <img src={TdmSvg} alt="" style={{ width: '25px', height: '32px' }} />,
          text: this.intlMsg.msg('sidebar.menuitems.tdm'),
          onClick: () => pushState('/network/tdm'),
          active: view === 'tdm',
          show: config.profile === 'cube',
        }, {
          icon: <img src={HeartMapSvg} alt="" style={{ width: '25px', height: '32px' }} />,
          text: this.intlMsg.msg('sidebar.menuitems.tdmstatis'),
          onClick: () => pushState('/network/tdmstatis'),
          active: view === 'tdmstatis',
          show: config.profile === 'cube',
        }]}
      />
    );
  }

  render() {
    const { plan: { status, data } } = this.state;
    if (status !== 'success') {
      return <PageLoading />;
    }
    if (data.tier === 1) {
      return <PageNoPerm />;
    }
    return (
      <div>
        {this.renderSideBar()}
        <SidebarContainer>
          <div className={styles.view}>
            {this.props.children}
          </div>
        </SidebarContainer>
      </div>
    );
  }
}

Network.defaultProps = defaultProps;
Network.propTypes = propTypes;

const mapStateToProps = (state, ownProps) => ({
  view: ownProps.location.pathname.split('/')[2] || '',
  plan: state.billing.plan,
});

const mapDispatchToProps = {
  pushState: routerActions.push,
};

export default connect(mapStateToProps, mapDispatchToProps)(injectIntl(Network));




// WEBPACK FOOTER //
// ./src/containers/Network/index.jsx